import 'jquery';

export default {
  ready() {
    jQuery("#header-md-hours").hide();
    jQuery("#header-btn-hours").click(function () {
      jQuery("#header-md-hours").slideToggle(100);
    });

    jQuery('#btn-menu').click(function (event) {
      jQuery('#sliding-nav').addClass('active');
    });

    jQuery('#sliding-nav').click(function (event) {
      jQuery('#sliding-nav').removeClass('active');
    });

    jQuery('#desktop-nav ul li').mouseleave(function (event) {
      if (jQuery(this).children('ul').length > 0) {
        jQuery(this).children('ul').removeClass('sub-menu-open');
        jQuery(this).children('.header-lineup-container').removeClass('sub-menu-open');
        //event.stopPropagation();
        event.preventDefault();
      }
    });
    jQuery('#desktop-nav ul:not(.sub-menu) > li').mouseover(function (event) {
      if (jQuery(this).children('ul').length > 0) {

        jQuery(this).children('ul').addClass('sub-menu-open');
        jQuery(this).children('.header-lineup-container').addClass('sub-menu-open');
        event.stopPropagation();
        event.preventDefault();
      }
    });
    jQuery('#desktop-nav ul.sub-menu > li').mouseover(function (event) {
      if (jQuery(this).children('ul').length > 0) {
        jQuery(this).children('ul').addClass('sub-menu-open');
        jQuery(this).children('ul').css("margin-left", "30px");
        event.stopPropagation();
        event.preventDefault();

        // Ejemplo de uso cuando se abre el menú
      const menu = document.querySelector('#desktop-nav ul > li > ul.sub-menu-open > li > ul.sub-menu-open');
      const trigger = document.querySelector('#desktop-nav ul > li > ul.sub-menu-open > li.menu-item-has-children a'); // selector del elemento que abre el menú
      adjustMenuPosition(menu, trigger);
      }
    });

    jQuery('#side-nav ul li, #sliding-nav #desktop-nav-mobile ul li, #sliding-nav #desktop-nav-vertical ul li').unbind('click').click(function (event) {
      jQuery(this).children('ul').children('li').click(function (event) {
        if (jQuery(this).children('ul').length == 0) {
          jQuery('#sliding-nav').removeClass('active')
          event.stopPropagation();
          return;
        }
      });

      if (jQuery(this).children('ul').length > 0 && jQuery(this).children('ul').hasClass('sub-menu-open')) {
        jQuery(this).children('ul').removeClass('sub-menu-open');
        jQuery(this).removeClass('first-level-menu-item-active');
        event.stopPropagation();
        event.preventDefault();

      } else if (jQuery(this).children('ul').length > 0) {
        jQuery(this).siblings().removeClass('first-level-menu-item-active');
        jQuery('#side-nav ul li, #sliding-nav #desktop-nav-mobile ul li, #sliding-nav #desktop-nav-vertical ul li').not(this).children("ul").removeClass('sub-menu-open');
        jQuery(this).parent().addClass('sub-menu-open');
        if(!jQuery(this).hasClass('second-level-menu-item-active'))
         jQuery(this).addClass('first-level-menu-item-active');
        
        jQuery(this).children('ul').addClass('sub-menu-open');
        event.stopPropagation();
        event.preventDefault();
      }
    });

    /* Close on orientation change */
    $(window).on("orientationchange", function (event) {
      jQuery('#sliding-nav').removeClass('active');
    });

    /* Omnisearch */
    jQuery(".header-search-btn, .close-search-svg").on("click", function () {
      jQuery("#header-omnisearch").animate({ width: 'toggle' });
      var hideOmnisearch = jQuery(".header-next-to-omnisearch-hook").hasClass("omnisearch-hook-not-hide");
      jQuery("#search").focus();
      if (jQuery("#section-buttons").hasClass("active")) {
        jQuery("#section-buttons").removeClass("active");
        

        if (window.screen.width >= 1024 && !hideOmnisearch)
          jQuery(".header-next-to-omnisearch-hook").fadeIn("slow");

      } else {
        jQuery("#section-buttons").addClass("active")

        if (window.screen.width >= 1024 && !hideOmnisearch)
          jQuery(".header-next-to-omnisearch-hook").fadeOut("slow");
      }
    });

    /* Megamenu */
    jQuery(".header-burger-btn").on("click", function () {
      // Close omniseach if open
      if (jQuery("#header-omnisearch").is(":visible")) {
        jQuery("#header-omnisearch").animate({ width: 'toggle' });
        jQuery("#section-buttons").removeClass("active");
        jQuery(".header-next-to-omnisearch-hook").fadeIn("slow");
      }
      
      if (jQuery("#header-mm").hasClass("invisible")) {
        jQuery("#header-mm").removeClass("invisible opacity-0");
        jQuery("#header-mm").addClass("visible opacity-100");
        jQuery(".header-burger-btn").addClass("active");
        jQuery(".black-logo-section").addClass("lbx-open");
      }
      else {
        jQuery("#header-mm").addClass("invisible opacity-0");
        jQuery("#header-mm").removeClass("visible opacity-100");
        jQuery(".header-burger-btn").removeClass("active");
        jQuery(".black-logo-section").removeClass("lbx-open");
      }
    });

    /* Click outside to close side menu */
    $(document).mouseup(function (e) {
      let container = $("#header-mm");
      let menuBtn = $(".header-burger-btn");

      // If the target of the click isn't the container
      if (!container.is(e.target) && container.has(e.target).length === 0 && !menuBtn.is(e.target) && menuBtn.has(e.target).length === 0 && !jQuery("#header-mm").hasClass("invisible")) {
        jQuery("#header-mm").addClass("invisible opacity-0");
        jQuery("#header-mm").removeClass("visible opacity-100");
        jQuery(".header-burger-btn").removeClass("active");
        jQuery("#ch-burguer").prop("checked", false);
      }
    });

    jQuery('#side-nav .sub-menu a').on('click', function (event) {
      
      if (!jQuery(this).parent().hasClass('menu-item-has-children')) { 
        if (jQuery(this).attr('target') != '_blank') {
          window.location.href = jQuery(this).attr('href');
  
          jQuery("#header-mm").addClass("invisible opacity-0");
          jQuery("#header-mm").removeClass("visible opacity-100");
          jQuery(".header-burger-btn").removeClass("active");
          jQuery("#ch-burguer").prop("checked", false);
        }
        else {
          window.open(jQuery(this).attr('href'), '_blank').focus();
  
          jQuery("#header-mm").addClass("invisible opacity-0");
          jQuery("#header-mm").removeClass("visible opacity-100");
          jQuery(".header-burger-btn").removeClass("active");
          jQuery("#ch-burguer").prop("checked", false);
        }
      }
      else {
        
        if (!jQuery(this).parent().hasClass('second-level-menu-item-active'))
        {
          jQuery(this).parent().siblings().removeClass('second-level-menu-item-active');
          jQuery(this).parent().removeClass('first-level-menu-item-active');
          jQuery(this).parent().addClass('second-level-menu-item-active');
        }
        else
          jQuery(this).parent().removeClass('second-level-menu-item-active');
      }
      
    });

    
    //Fomerly toggleMain from header-4
    jQuery(".lbx-icon-modal").on("click", function () {
      var dataMain = $(this).attr("data-main");
      var dataComponent = $(this).attr("data-component");
      const mainDOM = jQuery("#" + dataMain);
      var idMains = [dataMain];
      idMains.map(mainElementID => {
        const mainElement = jQuery("#" + mainElementID);
        // another menu
        if (mainElement[0] != mainDOM[0]) {
          // is open 
          if (mainElement.hasClass('lbx-not-collapsed')) {
            // collapse 
            mainElement.removeClass('lbx-not-collapsed')
            mainElement.addClass('lbx-collapsed')
          }
        }
        // menu to open
        else {
          // is open
          if (mainElement.hasClass('lbx-not-collapsed')) {
            // collapse 
            mainElement.removeClass('lbx-not-collapsed')
            mainElement.addClass('lbx-collapsed')
          }
          // is closed
          else {
            mainElement.addClass('lbx-not-collapsed')
            mainElement.removeClass('lbx-collapsed')
          }
        }
      })
    });

    function adjustMenuPosition(menuElement, triggerElement) {
      const menuWidth = menuElement.offsetWidth;
      menuElement.classList.remove('submenu-left', 'submenu-right');
      const triggerRect = triggerElement.getBoundingClientRect();
      const leftSpace = triggerRect.left;
      const rightSpace = window.innerWidth - triggerRect.right;

      if (rightSpace < menuWidth && leftSpace > menuWidth) {
        menuElement.classList.add('submenu-left');
      }
      else {
        menuElement.classList.add('submenu-right');
      }
    }

    /* Flex mega menu */
    if (jQuery('#desktop-nav ul li').hasClass("flex-megamenu")) {

      function getAllInventory(callback) {
        let lang = document.documentElement.lang === 'fr-CA' ? '_fr' : '';
        const version = getJSONTimestamp(5);
        const url = `/wp-content/uploads/data/inventory${lang}.json?v=${version}`;

        fetch(url)
          .then(res => res.ok ? res.json() : Promise.reject())
          .then(data => {
            if (data && data.vehicles) {
              callback(data.vehicles);
            } else {
              callback([]);
            }
          })
          .catch(() => {
            callback([]);
          });
      }

      function slugify(text) {
        return text
          .toLowerCase()
          .trim()
          .replace(/[\s_]+/g, '-')
          .replace(/[^\w\-]+/g, '')
          .replace(/\-\-+/g, '-');
      }

      function updateMenuCounts(inventory) {
        const safeSlug = (v) => v ? slugify(String(v).toLowerCase()) : null;

        // Cache regex para reutilizar
        const COUNT_REGEX = /\s\(\d+\)$/;

        // Constantes movidas fuera del loop
        const HYBRID_SLUGS = new Set(
          ['hybrid', 'phev', 'plug-in-hybrid', 'plug in hybrid', 'plug-in hybrid']
            .map(s => s.replace(/\s+/g, '-'))
        );

        const PHEV_MAP = {
          'corsair-phev': 'corsair',
          'nautilus-phev': 'nautilus'
        };

        const SUPPORTED_FLAGS = ['special', 'certified', 'asis', 'incoming', 'demo'];
        const FUEL_TYPE_FLAGS = ['gas', 'hybrid', 'electric', 'diesel'];

        function expandModelAliases(modelSlug) {
          const m = safeSlug(modelSlug);
          const ALIAS = {
            'sierra-hd': [
              'sierra-hd', 'sierra-2500hd', 'sierra-3500hd',
              'sierra-2500-hd', 'sierra-3500-hd',
              'sierra 2500hd', 'sierra 3500hd',
              'sierra 2500 hd', 'sierra 3500 hd'
            ],
            'silverado-hd': [
              'silverado-hd', 'silverado-2500hd', 'silverado-3500hd',
              'silverado-2500-hd', 'silverado-3500-hd',
              'silverado 2500hd', 'silverado 3500hd',
              'silverado 2500 hd', 'silverado 3500 hd'
            ],
            'super-duty': [
              'super-duty', 'super-duty-f-250-srw', 'super-duty-f-250-drw',
              'super-duty-f-350-srw', 'super-duty-f-350-drw',
              'super-duty-f-450-drw', 'super-duty-f-450-srw',
              'super-duty-f-550-drw', 'super-duty-f-550-srw',
              'super-duty-f-650-straight-frame-gas'
            ],
            'transit': ['transit-cargo-van'],
          };
          const base = ALIAS[m] || [m];
          return new Set(base.map(safeSlug));
        }

        // Pre-procesar inventario una sola vez
        const processedInventory = inventory.map(item => {
          const price = item.price == null || item.price === '' 
            ? null 
            : Number(String(item.price).replace(/[^\d.]/g, ''));
          
          return {
            make: safeSlug(item.make),
            model: safeSlug(item.model),
            trim: safeSlug(item.trim),
            fueltype: safeSlug(item.fueltype)?.replace(/\s+/g, '-'),
            condition: (item.condition || '').toLowerCase(),
            bodystyle: safeSlug(item.bodystyle),
            type: safeSlug(item.type),
            price: isNaN(price) ? null : price,
            tags: new Set(
              String(item.tags || '')
                .split(',')
                .map(t => safeSlug(t.trim()))
                .filter(Boolean)
            ),
            flags: item, // Mantener referencia para flags
          };
        });

        // Helper para extraer valores de clases
        function parseClasses(classes) {
          const result = {
            filters: {
              makes: [],
              models: [],
              trims: [],
              bodystyles: [],
              types: [],
            },
            requiredTags: [],
            requiredFlags: [],
            requiredFuelTypes: [],
            filterByNew: false,
            filterByUsed: false,
          };

          for (const cls of classes) {
            if (cls.startsWith('fmm-make-')) result.filters.makes.push(safeSlug(cls.slice(9)));
            else if (cls.startsWith('fmm-model-')) result.filters.models.push(safeSlug(cls.slice(10)));
            else if (cls.startsWith('fmm-trim-')) result.filters.trims.push(safeSlug(cls.slice(9)));
            else if (cls.startsWith('fmm-bodystyle-')) result.filters.bodystyles.push(safeSlug(cls.slice(14)));
            else if (cls.startsWith('fmm-type-')) result.filters.types.push(safeSlug(cls.slice(9)));
            else if (cls.startsWith('fmm-maxprice-')) result.filters.maxPrice = parseInt(cls.slice(13), 10);
            else if (cls.startsWith('fmm-tag-')) result.requiredTags.push(safeSlug(cls.slice(8)));
            else if (cls === 'fmm-new') result.filterByNew = true;
            else if (cls === 'fmm-used') result.filterByUsed = true;
            else if (SUPPORTED_FLAGS.some(flag => cls === `fmm-${flag}`)) {
              result.requiredFlags.push(cls.slice(4));
            }
            else if (FUEL_TYPE_FLAGS.some(flag => cls === `fmm-${flag}`)) {
              result.requiredFuelTypes.push(safeSlug(cls.slice(4)));
            }
          }

          return result;
        }

        jQuery('.fmm-add-count').each(function () {
          const el = jQuery(this);
          const classes = (el.attr('class') || '').split(/\s+/);
          const config = parseClasses(classes);

          // Early return si no hay filtros
          const hasFilters = config.filters.makes.length > 0 ||
                           config.filters.models.length > 0 ||
                           config.filters.trims.length > 0 ||
                           config.filters.bodystyles.length > 0 ||
                           config.filters.types.length > 0 ||
                           config.filters.maxPrice != null ||
                           config.requiredTags.length > 0 ||
                           config.requiredFuelTypes.length > 0 ||
                           config.requiredFlags.length > 0 ||
                           config.filterByNew ||
                           config.filterByUsed;
          if (!hasFilters) return;

          const { makes, models, trims, bodystyles, types, maxPrice } = config.filters;

          // Convertir a Sets para búsqueda O(1)
          const makeSet = makes.length > 0 ? new Set(makes) : null;
          const trimSet = trims.length > 0 ? new Set(trims) : null;
          const bodystyleSet = bodystyles.length > 0 ? new Set(bodystyles) : null;
          const typeSet = types.length > 0 ? new Set(types) : null;

          // Procesar modelos y PHEV - expandir todos los modelos
          let modelCandidatesSet = null;
          let requireHybrid = false;

          if (models.length > 0) {
            const allModelCandidates = new Set();
            for (const model of models) {
              const phevBase = PHEV_MAP[model];
              if (phevBase) requireHybrid = true;
              const expanded = expandModelAliases(phevBase || model);
              expanded.forEach(m => allModelCandidates.add(m));
            }
            modelCandidatesSet = allModelCandidates;
          }

          // Contar items que coinciden
          const count = processedInventory.filter(item => {
            // Filtros básicos con soporte para múltiples valores (OR logic)
            if (makeSet && !makeSet.has(item.make)) return false;
            if (modelCandidatesSet && !modelCandidatesSet.has(item.model)) return false;
            if (trimSet && !trimSet.has(item.trim)) return false;
            if (bodystyleSet && !bodystyleSet.has(item.bodystyle)) return false;
            if (typeSet && !typeSet.has(item.type)) return false;

            // Condición
            if (config.filterByNew && item.condition !== 'new') return false;
            if (config.filterByUsed && item.condition !== 'used') return false;

            // Hybrid check
            if (requireHybrid && !HYBRID_SLUGS.has(item.fueltype)) return false;

            // Fuel types (usar .some() es más eficiente que loop)
            if (config.requiredFuelTypes.length > 0 && 
                !config.requiredFuelTypes.includes(item.fueltype)) return false;

            // Flags
            if (config.requiredFlags.length > 0 && 
                !config.requiredFlags.every(flag => item.flags[flag])) return false;

            // Precio
            if (maxPrice != null && (item.price == null || item.price > maxPrice)) return false;

            // Tags (usar Set.has() es O(1))
            if (config.requiredTags.length > 0 && 
                !config.requiredTags.every(tag => item.tags.has(tag))) return false;

            return true;
          }).length;

          // Actualizar HTML
          const link = el.find('a').first();
          const htmlOriginal = link.html() || '';
          const htmlSinCount = htmlOriginal.replace(COUNT_REGEX, '');

          link.html(count > 0 ? `${htmlSinCount} (${count})` : htmlSinCount);
        });
      }

      function getJSONTimestamp(intervalMinutes = 5) {
        const now = new Date();
        const interval = intervalMinutes * 60 * 1000;
        return Math.floor(now.getTime() / interval);
      }

      getAllInventory(function (vehicles) {
        updateMenuCounts(vehicles);
      });

      document.querySelectorAll('.flex-megamenu ul.sub-menu').forEach(ul => {
        const columns = [];
        const others = [];

        ul.querySelectorAll(':scope > li').forEach(li => {
          if (li.classList.contains('fmm-column')) {
            columns.push(li);
          } else {
            others.push(li);
          }
        });

        if (others.length) {
          const headerWrapper = document.createElement('ul');
          headerWrapper.className = 'flex-mega-header-links';
          others.forEach(li => headerWrapper.appendChild(li));
          ul.prepend(headerWrapper);
        }

        if (columns.length) {
          const columnWrapper = document.createElement('div');
          columnWrapper.className = 'flex-mega-column-wrap';
          columns.forEach(col => columnWrapper.appendChild(col));
          ul.appendChild(columnWrapper);
        }
      });

    }
  }
}